export default __webpack_public_path__ + "static/media/hydrant-system-icon.83f70397.svg";